import { useDefaultPeriod } from "./income-defaults";

export function PeriodSelect({ periods, date }: { periods: any[]; date?: string }) {
  const open = periods.filter((p) => p.status === "Open");
  // F-120/F-128: follow the effective date to the open period that contains it; the person can still override.
  const [value, setChosen] = useDefaultPeriod(open, date);
  return (
    <label>
      Financial period
      <select name="periodId" required value={value} onChange={(e) => setChosen(e.target.value)}>
        {open.map((p) => (
          <option value={p.id} key={p.id}>
            {p.label}
          </option>
        ))}
      </select>
    </label>
  );
}
